import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// import { SocialLoginService } from 'ngx-social-login';
import configData from "../../../../assets/data/config.json";
import { MetaService } from 'src/app/shared-service/services/meta-service.service';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { UserService } from 'src/app/shared-service/services/user.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-left-filter-panel',
  templateUrl: './left-filter-panel.component.html',
  styleUrls: ['./left-filter-panel.component.css']
})
export class LeftFilterPanelComponent implements OnInit {

  authorsList=[];
  offerzoneBooks=[];

  isBooksCount=0;
  BooksData=[]
  totalBooksData=[];
  upscBooks=[];
  sscBooks=[];
  bankBooks=[];
  ncertBooks=[];
  upcomingBooks=[];
  newArrivalsBooks=[];
  ComboBooksData=[];
  isLoggedIn=false;

  userData:any;

  isLazyAPIfetched=false;

  newarrivalbookId = '';
bestsellerbookId='';
upcomingbookId='';
combobookId ='';

  constructor( 
    @Inject(DOCUMENT) private _document: Document,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
    private quizService: QuizService,
    private formBuilder: FormBuilder,
    // private service: SocialLoginService,
    private metaServiceCustom: MetaService,
    ) {
      var self=this;
      // this._document.addEventListener("scroll", this.onContentScrolled.bind(self, this));
      this.newarrivalbookId = configData.NEW_ARRIVAL_BOOKS_ID;
      this.bestsellerbookId = configData.BEST_SELLER_BOOKS_ID;
      this.upcomingbookId = configData.UPCOMING_BOOKS_ID;
      this.combobookId = configData.COMBO_BOOKS_ID;
     }

  ngOnInit(): void {
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.isLoggedIn = true;
    }


  }

  onContentScrolled(...args) {
    let scroll = window.pageYOffset;
    if(scroll > 50) {
      // if(!this.isLazyAPIfetched) {
      //   this.isLazyAPIfetched = true;     
      //   this.getOfferzoneBooksData();
      //   this.getBooksData();
      //   this.getComboBooksData();
      //   this.getNewArrivalBooksData();
      //   this.getUpcomingBooksData();
      //   // this.getSections();
      // }
      
    }
  }

  redirect(uri:string){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([uri]));
  }

  filterOnLastDate(recent) {
    // this.router.navigate(['/books/recent/'+recent]);
    var urlToRoute = '/books/recent/'+recent;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/recent/'+recent;
    }
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  filterOnLanguage(language) {
    var urlToRoute = '/books/language/'+language;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/language/'+language;
    }
    // this.router.navigate(['/books/language/'+language]);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  filterOnAuthorId(authorId) {
    var urlToRoute = '/books/author/'+authorId;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/author/'+authorId;
    }
    // this.router.navigate(['/books/author/'+authorId]);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  filterOnRating(rating) {
    var urlToRoute = '/books/rating/'+rating;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/rating/'+rating;
    }
    // this.router.navigate(['/books/rating/'+rating]);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  filterOnPrice(min, max) {
    var urlToRoute = '/books/price/'+min+'/'+max;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/price/'+min+'/'+max;
    }
    // this.router.navigate(['/books/price/'+min+'/'+max]);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  filterOnDiscount(discount) {
    var urlToRoute = '/books/discount/'+discount;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/discount/'+discount;
    }
    // this.router.navigate(['/books/discount/'+discount]);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([urlToRoute]));
  }

  getAuthorsList() {
    this.quizService.getAuthorsList().subscribe((res:any) => {
      if(res && res.data) {
        this.authorsList = res.data;
      }
    })
  }

  openDetail(book) {
    var urlToRoute = '/books/recent/'+bookTitle+'/'+book.id;
    if(this.isLoggedIn) {
      urlToRoute='/user/user-books/recent/'+bookTitle+'/'+book.id;
    }
    var bookTitle = book.title.replace(/ /g,'-');
    this.router.navigate([urlToRoute]);
  }

  getOfferzoneBooksData() {
    // var data = {};
    // data['customtag'] = '89';
    this.quizService.getOfferZone().subscribe((res:any) => {
      if(res && res.data) {
        this.offerzoneBooks = res.data;

      }
    })
  }

  getBooksData() {
    var data = {};
    data['customtag'] = this.bestsellerbookId;
    this.quizService.getBooksBySearch(data).subscribe((res:any) => {
      if(res && res.data) {
        this.BooksData = res.data;
      }
      this.isBooksCount = this.isBooksCount+1;
      if(this.isBooksCount == 4) {
       this.setCatWiseBooksData();
      }
    })
  }

  getComboBooksData() {
    var data = {};
    data['customtag'] = this.combobookId;
    this.quizService.getBooksBySearch(data).subscribe((res:any) => {
      if(res && res.data) {
        this.ComboBooksData = res.data;
      }
      this.isBooksCount = this.isBooksCount+1;
      if(this.isBooksCount == 4) {
        this.setCatWiseBooksData();
      }
    })
  }

  getNewArrivalBooksData() {
    var data = {};
    data['customtag'] = this.newarrivalbookId;
    this.quizService.getBooksBySearch(data).subscribe((res:any) => {
      if(res && res.data) {
        this.newArrivalsBooks = res.data;
      }
      this.isBooksCount = this.isBooksCount+1;
      if(this.isBooksCount == 4) {
        this.setCatWiseBooksData();
      }
    })
  }

  getUpcomingBooksData() {
    var data = {};
    data['customtag'] = this.upcomingbookId;
    this.quizService.getBooksBySearch(data).subscribe((res:any) => {
      if(res && res.data) {
        this.upcomingBooks = res.data;
      }
      this.isBooksCount = this.isBooksCount+1;
      if(this.isBooksCount == 4) {
        this.setCatWiseBooksData();
      }
    })
  }

  setCatWiseBooksData() {
    this.totalBooksData = [...this.BooksData, ...this.upcomingBooks, ...this.newArrivalsBooks, ...this.ComboBooksData];
    this.upscBooks = this.totalBooksData.filter((book) => book.main_category == '312');
    this.sscBooks = this.totalBooksData.filter((book) => book.main_category == '313');
    this.bankBooks = this.totalBooksData.filter((book) => book.main_category == '361')
    this.ncertBooks = this.totalBooksData.filter((book) => book.main_category == '360');
  }



 


}
